import CalendarScheduleModel from "@/modules/calendar/core/models/CalendarScheduleModel";
import {Dayjs} from "@dracul/dayjs-frontend";

class CalendarModel {
    constructor({id, name, description = '', identifier, user, priority = 1, schedule = []}) {
        this.className = 'CalendarModel'

        this.id = id
        this.name = name
        this.description = description
        this.identifier = identifier
        this.user = user
        this.priority = priority
        if (!schedule || schedule.length === 0) {
            this.initBasicSchedules()
        } else {

            this.schedule = schedule.map(i => new CalendarScheduleModel(i))
        }

    }

    initBasicSchedules() {
        this.schedules = [
            new CalendarScheduleModel({dayOfWeek: 1, dayName: 'monday'}),
            new CalendarScheduleModel({dayOfWeek: 2, dayName: 'tuesday'}),
            new CalendarScheduleModel({dayOfWeek: 3, dayName: 'wednesday'}),
            new CalendarScheduleModel({dayOfWeek: 4, dayName: 'thursday'}),
            new CalendarScheduleModel({dayOfWeek: 5, dayName: 'friday'}),
            new CalendarScheduleModel({dayOfWeek: 6, dayName: 'saturday'}),
            new CalendarScheduleModel({dayOfWeek: 0, dayName: 'sunday'}),
        ]
    }

    getHour() {
        return Dayjs().format("HH:mm")
    }

    getDayOfWeek() {
        return Dayjs().day()
    }

    addExtendedTime(hour, extendedTime = 0) {
        let rHour = Dayjs(hour, "HH:mm").add(extendedTime, 'minute')
        return rHour.format("HH:mm")
    }

    get hasSchedule() {
        return this.schedule && this.schedule.length > 0
    }

    scheduleDay(dayOfWeek) {
        return this.schedule.find(i => i.dayOfWeek == dayOfWeek)
    }

    isActive(dateHour, extendedTime = 0) {
        if (!dateHour) {
            dateHour = Dayjs()
        }

        if (!Dayjs.isDayjs(dateHour)) {
            throw new Error("dateHour must be a valid Dayjs object")
        }

        let dayOfWeek = dateHour.day()

        let result = false

        if (this.hasSchedule) {

            let scheduleDay = this.scheduleDay(dayOfWeek)
            if (scheduleDay && scheduleDay.activeHours && scheduleDay.activeHours.length > 0) {
                scheduleDay.activeHours.forEach(activeHours => {
                    let [hourFrom, minuteFrom] = activeHours.from.split(":")
                    let activeHoursFrom = dateHour.hour(hourFrom).minute(minuteFrom).second(0)
                    let [hourTo, minuteTo] = activeHours.to.split(":")
                    let activeHoursTo = dateHour.hour(hourTo).minute(minuteTo).second(0).add(extendedTime, 'minute')

                    if ((activeHoursFrom.isBefore(dateHour) || activeHoursFrom.isSame(dateHour)) && activeHoursTo.isAfter(dateHour)) {
                        result = true
                    }

                })
            }

        }

        //console.log("isActive", dateHour, dayOfWeek, extendedTime, result)

        return result
    }
}

export default CalendarModel;
